module.exports = __webpack_public_path__ + "media/images/hitfun/icon.notification.pink-9225a936660be00c63b27e0638d9e0e8.svg";